<template>
  <div class="encode-record">
    <Header>
      <div slot="nav">
        <span class="" title="加密文件" @click="$router.push('/homepage')">主页</span>
        <span class="active" title="查看7天内加密文件" @click="$router.push('/record')">加密记录</span>
      </div>
      <div slot="info">
        <div class="date left">
          <span>{{ myDate }}</span>
        </div>
        <div class="user left">
          <span class="" @click="showDepartment = !showDepartment" :title="userDepartment">
            你好! {{userName}}
          </span>
        </div>
        <div class="help left">
          <span @click="toHelp"><img src="@/assets/help.svg" alt=""> 帮助</span>
        </div>
        <div class="login left">
          <span title="退出登录" @click="logout"><img src="@/assets/sign_out.svg" alt=""> 退出</span>
        </div>
      </div>
    </Header>
    <main>
      <div class="table-container">
        <div class="title">文档列表</div>
        <div class="table">
          <el-table ref="table"
            :data="tableData"
            border
            size="medium"
            :height="windowAutoHeight"
            empty-text="暂无数据">
            <el-table-column
              prop="fileName"
              label="加密文档"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="name"
              label="授权对象"
              width="380"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="encodeDate"
              label="加密时间"
              width="180">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Header from '@/components/Header'
  import {postEncryptList
  } from '@/common/http/server'
  import {
    getStorage,
    setStorage,
  } from '@/common/utils/localStorage'
  import { format } from "@/common/utils/date";
  import {
    Table,
    TableColumn,
    Dialog,
    Button,
    Radio,
    Tabs,
    TabPane,
    Checkbox,
    DatePicker,
    Input,
    Upload,
    Collapse,
    CollapseItem,
    Popover,
    Loading,
    Tree,
    CheckboxGroup,
    Pagination
  } from 'element-ui'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Dialog)
  Vue.use(Button)
  Vue.use(Radio)
  Vue.use(Tabs)
  Vue.use(TabPane)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(DatePicker)
  Vue.use(Input)
  Vue.use(Upload)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  Vue.use(Popover)
  Vue.use(Loading)
  Vue.use(Tree)
  Vue.use(Pagination)

  export default {
    name: 'Record',
    components: { Header },
    data() {
      return  {
        myDate: new Date().toLocaleString(),
        userName: '',
        userDepartment: '',
        tableData: [],
        windowAutoHeight: window.innerHeight - 150
      }
    },
    created() {
      this.getUserInfo()
      this.upDateTableData()
    },
    mounted() {
      this.myDate = format(new Date());
      let _this = this
      this.timer = setInterval(function () {
        _this.myDate = format(new Date());
      }, 1000);   
      
      window.onresize = function windowResize () {
        _this.windowAutoHeight = window.innerHeight - 150;
      }      
    },
    methods: {      
      toHelp() {
        let linkTo = this.$router.resolve({path: '/help'})
        window.open(linkTo.href, '_blank')
      },
      logout() {
        setStorage('user', {})
        setStorage('uploadList', [])
        this.$router.push('/login')
      },
      getUserInfo() {
        const user = getStorage('user')
        this.userName = user.displayname
        this.userDepartment = user.departmentname
      },

      async upDateTableData() {
        let requestData = {
          data: {
            U: "",
            I: 0,
            P: 1000
          }
        }
        let userId = getStorage('user').cn
        requestData.data.U=userId;
        let res= await postEncryptList(requestData)
        this.tableData = res.Table||[]
      },
    }
  }
</script>
<style lang="scss">
  @import "../common/theme/myTheme.scss";

  main {
    padding: 10px;
    background-color: rgb(247, 248, 251);
    .table-container {
      padding: 10px;
      background-color: #fff;
      .title {
        font-size: 20px;
        margin-bottom: 20px;
      }     
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/encodeRecord.vue